<template>
    <b-modal
        id="portfolio-edit-publishing-modal"
        v-model="modal"
        :title="$t('portfolio.publish_assignment')"
        modal-class="apprentice-default-modal"
        size="md"
        @ok="storePublishing">
        <!--
                     :ok-title="'Opslaan'"
                     :cancel-title="$t('common.cancel')"
                     cancel-variant="outline-primary"-->
        <div class="portfolio">
            <p v-if="!update">
                <span v-if="this.groupIn.children.length">
                    {{
                        $t(
                            'portfolio.this_group_has_subgroups_if_you_publish_this_assignment_you_will_do_it_for_all_your_subgroups',
                        )
                    }}
                </span>
                <span v-else>
                    {{ $t('portfolio.are_you_sure_you_want_to_publish_this_assignment') }}
                </span>
            </p>
            <p v-else>
                {{ $t('portfolio.do_you_want_to_change_the_publication_moment') }}
            </p>
            <div class="publishing-toggle">
                <b-form-group
                    class="radio-button-group"
                    v-slot="{ ariaDescribedby }"
                    :label="$t('portfolio.publish_assignment')">
                    <b-form-radio
                        class="apprentice-radiobutton"
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="now-or-the-future"
                        value="now"
                        >Nu
                    </b-form-radio>
                    <b-form-radio
                        class="apprentice-radiobutton"
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="now-or-the-future"
                        value="future"
                        >{{ $t('portfolio.in_the_future') }}
                    </b-form-radio>
                </b-form-group>
            </div>

            <div
                class="publishing"
                v-if="selected === 'future'">
                {{ $t('portfolio.set_future_publish_date') }}
                <div class="date">
                    <b-form-group
                        label="Datum"
                        label-for="publishing-datepicker-input">
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="publishing-datepicker-input"
                            v-model.lazy="date"
                            :config="dateConfig"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            today-variant="primary"
                            nav-button-variant="primary"
                            locale="nl"
                            :aria-controls="$t('portfolio.choose_date')"
                            label-reset-button="reset"
                            :label-no-date-selected="$t('portfolio.no_date_selected')"
                            menu-class="datedropdown"
                            :date-format-options="{
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                weekday: 'short',
                            }">
                        </b-form-datepicker>
                    </b-form-group>
                </div>
                <div class="time">
                    <b-form-group
                        :label="$t('portfolio.time')"
                        label-for="publishing-timepicker-input">
                        <design-2021-apprentice-timepicker-component v-model.lazy="time">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <!-- -->
            <b-button
                @click="cancel()"
                variant="outline-primary"
                >{{ $t('common.cancel') }}
            </b-button>
            <b-button
                class="remove"
                v-if="update"
                @click="removePublishing"
                variant="outline-danger">
                <i class="btn-remove"></i>{{ $t('portfolio.withdraw') }}
            </b-button>
            <b-button
                id="ok"
                @click="storePublishing"
                variant="primary"
                >{{ $t('common.save') }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-publishing-modal-component',
    props: {
        groupIn: {
            type: Object,
            required: true,
        },
        ordsIn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            assignment: {},
            selected: 'now',
            dateTime: null,
            time: '12:00',
            update: false,
            date: null,
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            },
            timeConfig: {
                format: 'H:mm',
                useCurrent: false,
                labelCloseButton: this.$t('common.close'),
                noCloseButton: true,
                icons: {
                    close: 'fa fa-times-circle',
                },
            },
            modal: false,
        };
    },
    methods: {
        show(assignment) {
            this.assignment = assignment;
            if (!!assignment.publishings.length) {
                this.dateTime = new Date(assignment.publishings[0].published_at);
                this.update = true;
                this.selected = 'future';
            } else {
                this.update = false;
                this.selected = 'now';
                this.dateTime = new Date();
            }
            this.date = `${this.dateTime.getFullYear()}-${String(this.dateTime.getMonth() + 1).padStart(2, '0')}-${String(this.dateTime.getDate()).padStart(2, '0')}`;
            this.time = `${String(this.dateTime.getHours()).padStart(2, '0')}:${String(this.dateTime.getMinutes()).padStart(2, '0')}:${String(this.dateTime.getSeconds()).padStart(2, '0')}`;
            this.modal = true;
        },

        storePublishing() {
            this.alert.saving();

            const data = {
                published_at: this.date + ' ' + this.time,
                group_id: this.groupIn.id,
                assignment_id: this.assignment.id,
            };

            if (this.groupIn.children.length > 0) {
                this.alert
                    .confirm(
                        this.$t('portfolio.publish'),
                        this.$t(
                            'portfolio.are_you_sure_you_want_to_edit_this_deadline_the_deadline_for_sub_groups_will_be_overwritten',
                        ),
                        this.$t('portfolio.publish'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.axios.post(this.routes.assignmentPublishing(), data).then(
                                (response) => {
                                    if (this.ordsIn) {
                                        this.$emit('update-publishing', response.data);
                                    } else {
                                        this.assignment.publishings = [response.data];
                                        this.$emit('update-publishing', this.assignment);
                                    }
                                    this.alert.success();
                                    this.modal = false;
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                        }
                    });
            } else {
                this.axios.post(this.routes.assignmentPublishing(), data).then(
                    (response) => {
                        if (this.ordsIn) {
                            this.$emit('update-publishing', response.data);
                        } else {
                            this.assignment.publishings = [response.data];
                            this.$emit('update-publishing', this.assignment);
                        }
                        this.alert.success();
                        this.modal = false;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        removePublishing() {
            this.alert
                .confirm(
                    this.$t('portfolio.withdraw_publication'),
                    this.groupIn.children.length
                        ? this.$t(
                              'portfolio.this_group_has_subgroups_if_you_make_this_assignment_invisible_you_will_also_do_it_for_all_subgroups_are_you_sure_you_want_to_do_this',
                          )
                        : this.$t('portfolio.are_you_sure_you_want_to_withdraw_the_publication_for_this_assignment'),
                    this.$t('portfolio.withdraw_publication'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios
                            .delete(
                                this.routes.assignmentPublishingRemove(
                                    this.assignment.publishings[0].id,
                                    this.groupIn.id,
                                ),
                            )
                            .then(
                                (response) => {
                                    if (this.ordsIn) {
                                        this.assignment.publishings[0].remove();
                                        this.$emit('update-publishing', null);
                                    } else {
                                        this.assignment.publishings = [];
                                        this.$emit('update-publishing', this.assignment);
                                    }
                                    this.modal = false;
                                    this.alert.success();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                    }
                });
        },
        cancel() {
            this.modal = false;
        },
    },
};
</script>

<style scoped lang="scss">
.publishing-toggle {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.remove {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'eight');
}

.radio-button-group {
    margin: $grid-gutter-width 0 map-get($grid-gutter-spacing, 'sixty') 0;
}
</style>
